import styled from "styled-components";

const Flex = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export { Flex }


// WEBPACK FOOTER //
// ./src/components/Flex/index.js